import React, { useContext } from 'react';
import { useLabels } from 'wsm-common-data';
import { FiltersContext } from '../contexts';

const AlertBanner = () => {
	const { alertState } = useContext(FiltersContext);
	const labels = useLabels();

	if (alertState !== 'partial' && alertState !== 'total') return null;

	const isPartial = alertState === 'partial';
	const variant = isPartial ? 'warning' : 'danger';
	const heading = isPartial
		? labels.get('INCENTIVES_STALE_PARTIAL_HEADING')
		: labels.get('INCENTIVES_STALE_TOTAL_HEADING');
	const body = isPartial
		? labels.get('INCENTIVES_STALE_PARTIAL_BODY')
		: labels.get('INCENTIVES_STALE_TOTAL_BODY');

	return (
		<div
			role="alert"
			aria-live="polite"
			className={`alert alert-${variant} mt-3 mb-3 px-3 py-2`}
		>
			<strong>{heading}</strong>
			{body && <p className="mb-0">{body}</p>}
		</div>
	);
};

export default AlertBanner;
